if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// ACCORDIONs
	document.querySelectorAll('[data-accordion]').forEach((acc) => {
		acc.querySelectorAll('[data-accordion_item]').forEach((item, i) => {
			const accHead = item.querySelector('[data-accordion_head]');
			const accBody = item.querySelector('[data-accordion_body]');
			accHead.addEventListener('click', (e) => {
				acc.querySelectorAll('[data-accordion_item]').forEach((citem) => {
					const cbody = citem.querySelector('[data-accordion_body]');
					if (accBody !== cbody) {
						cbody.slideUp(300, () => citem.classList.remove('active'));
					}
				});
				accBody.slideToggle(300, () => item.classList.toggle('active'));
			});

			if (i === 0) accHead.click();
		});
	});
	

	// TOGGLE MAIN NAV TABLET
	const headerNav = document.querySelector('.header .privary-navigation');
	if (headerNav) {
		headerNav.insertAdjacentHTML(
			'afterbegin',
			`<button data-toggle_nav class="header_close" type=button>
				<span class="header_burger-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1" shape-rendering="crispEdges"><path d="M 0 0 L 14 14 M 14 0 L 0 14" /></svg></span>
				<span class="header_burger-label">Menu</span>
			</button>`
		);
	}
	document.querySelectorAll('[data-toggle_nav]').forEach((btn) => {
		if (headerNav) {
			btn.addEventListener('click', (e) => {
				headerNav.classList.toggle('active');
			});
		}
	});

	// ADD MOBILE NAV LOGO
	if (document.querySelector('.navigation .inner') && document.querySelector('header')) {
		const headerLogo = document.querySelector('.header__logo img').dataset.scroll;
		if (headerLogo) {
			document.querySelector('.navigation .inner').insertAdjacentHTML('afterbegin', `<a href="/" class="navigation-logo" data-fromjs><img src="${headerLogo}" alt="Mobile Nav Logo"></a>`);
		}
	}

	// CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.remove('active');
			});
		}
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.add('active');
			});
		}
	});

	// MENUS OVERVIEW TOGGLE IMAGE
	document.querySelectorAll('[data-menuov]').forEach((mod) => {
		mod.querySelectorAll('[data-menuov-link]').forEach((link) => {
			link.addEventListener('mouseenter', () => {
				mod.querySelectorAll('[data-menuov-img], [data-menuov-link]').forEach((item) => item.classList.remove('active'));

				link.classList.add('active');
				mod.querySelector(`[data-menuov-img="${link.dataset.menuovLink}"]`).classList.add('active');
			});
		});
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.sym-slides';
	const swiperOps = {
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		const combinedOps = Object.assign({}, swiperOps, dataOps);

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	document.querySelectorAll('[data-swiper-prev]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slidePrev());
	});
	document.querySelectorAll('[data-swiper-next]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slideNext());
	});

	// LENIS
	const lenis = new Lenis({
		duration: 1.2,
		smooth: true,
		smoothTouch: false,
	});

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	// FANCYBOX - PREVENT LENIS
	$.fancybox.defaults.beforeShow = function (e) {
		[...e.current.$slide].forEach((slide) => slide.setAttribute('data-lenis-prevent', ''));
	};

	// FANCYBOX - PREVENT DUPLICATED ITEMS FROM SLIDER
	$('.swiper-slide:not(.swiper-slide-duplicate) [data-fancybox]').fancybox({
		autoFocus: false,
		backFocus: false,
	});
})();
